module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_SO.761ca72a.txt";